export default "__VITE_ASSET__C_rdN1yD__"